import { BC_CUSTOMER_TOKEN_NAME } from '@adapters/bigcommerce/constants';
import Cookies from 'js-cookie';

const checkSDKExistanceAndAddCustomAttribute = async () => {
  try {
    if (!window.NOIBUJS) {
      await new Promise((resolve) => {
        window.addEventListener('noibuSDKReady', resolve);
      });
    }

    const customerCookie = Cookies.get(BC_CUSTOMER_TOKEN_NAME);
    const sessionId = Cookies.get('sessionId');

    if (customerCookie) {
      window.NOIBUJS.addCustomAttribute('isLoggedIn', 'true');
    }

    if (sessionId) {
      window.NOIBUJS.addCustomAttribute('sessionId', sessionId);
    }
  } catch (error) {
    console.log('Error adding custom attributes to Noibu SDK', error);
  }
};

export default checkSDKExistanceAndAddCustomAttribute;
